import { Box, Skeleton } from '@machobear/design-system'
import { HighPriceWarning } from './high-price-warning'
import { LowPriceWarning } from './low-price-warning'
import { PriceError } from './price-error'
import { PriceOkMessage } from './price-ok-message'
import { useListingData } from '../../../context/listing-data'

export const PriceInsight = () => {
  const { averagePrice, priceDifference, loading } = useListingData()

  if (loading)
    return (
      <Box paddingY="xxsmall">
        <Skeleton.Shape width="100%" height="100px" />
      </Box>
    )

  if (!averagePrice || !priceDifference) {
    return <PriceError />
  }

  if (priceDifference > 6) {
    return <HighPriceWarning averagePrice={averagePrice} priceDifference={priceDifference} />
  }

  if (priceDifference < -5) {
    return <LowPriceWarning averagePrice={averagePrice} priceDifference={priceDifference} />
  }

  return <PriceOkMessage averagePrice={averagePrice} />
}
